import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { TEntityId } from '~/types/models'
import type { ICompanyMSTeamMember } from '@/types/company/models'
import { getTeamMemberDataById } from '~/api/msw/api/teamMembers/mockData'
import {
  TeamMemberRoleIds,
  getTeamMemberRoleById,
} from '~/services/selectLists/teamMemberRoles'

const companyMSTeamMemberListData =
  undefined as unknown as ICompanyMSTeamMember[]

export const getCompanyMSTeamMemberListData = getListDataFunctionFactory<
  ICompanyMSTeamMember[]
>({
  listData: companyMSTeamMemberListData,
  storageKey: 'companymsteammembers',
  getStartingListData: getStartingCompanyMSTeamMemberListData,
})

export async function getCompanyMSTeamMemberListDataByCMSId(id: TEntityId) {
  const listData = await getCompanyMSTeamMemberListData()
  return listData.filter(
    (cmstm: ICompanyMSTeamMember) => cmstm.companyMasterService.id === id
  )
}

export async function getCompanyMSTeamMemberDataById(
  id: TEntityId
): Promise<ICompanyMSTeamMember | undefined> {
  const listData = await getCompanyMSTeamMemberListData()
  return listData.find((otm: ICompanyMSTeamMember) => otm.id === id)
}

export async function getStartingCompanyMSTeamMemberListData(): Promise<
  ICompanyMSTeamMember[]
> {
  return [
    {
      id: 'XXCMSTM0006',
      hrid: 'CMSTM0006',
      companyMasterService: {
        id: 'XXCMS0001',
        label: 'DIA - Two Locations',
      },
      teamMember: await getTeamMemberDataById('XXTM0006')!,
      role: getTeamMemberRoleById(TeamMemberRoleIds.ACCOUNT_OWNER),
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
  ]
}
